'use strict';

export const recaptchaUpdater = type => {
  setInterval(function () {
    grecaptcha.ready(function () {
      grecaptcha.execute('6LdiCz0lAAAAAKQ8raGMeEmR9oyI_Db7Mzx7q-T-', { action: type }).then(function (token) {
        document.querySelector('[name="g-recaptcha-response"]').setAttribute('value', token);
      });
    });
  }, 100000);
};
